import {createContext, FC, PropsWithChildren, ReactNode, useEffect, useState} from "react";
import {userAPI} from "../../Redux/services/UserService";

interface AuthProviderProps {
    children: ReactNode;
}
export const AuthContext = createContext<any>(null)

export const AuthProvider:FC<AuthProviderProps> = ({children}) => {

    const [user, setUser] = useState<any>()
    const [trigger] = userAPI.useLazyFetchMeQuery()
    const [loading, setLoading] = useState(true);


    const getUser = async () => {
        try {
            const response = await trigger('').unwrap();
            setUser(response);
        } catch (error) {
            setUser(null);
        } finally {
            setLoading(false); // 👈 только теперь считаем, что всё загрузилось
        }
    };
    useEffect(() => {
        getUser()
    }, [])

    return (
        <AuthContext.Provider value={{user, setUser, loading, getUser}}>
            {children}
        </AuthContext.Provider>
    )
}